import BrokenLamp from "../../../../src/client/examples/json/broken-lamp.json";
import * as React from 'react';
export default {
  BrokenLamp,
  React
};